import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Sun, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) nav("/admin");
    else setError(res.error);
  };

  const field = "w-full rounded-xl border border-border bg-white px-4 py-3 text-secondary focus:outline-none focus:ring-2 focus:ring-primary/40 focus:border-primary transition-all";

  return (
    <div className="min-h-screen grid place-items-center bg-secondary relative grain overflow-hidden p-4">
      <motion.div
        initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
        className="relative w-full max-w-md rounded-3xl bg-white p-8 sm:p-10 shadow-2xl"
      >
        <div className="flex items-center gap-2 mb-8">
          <span className="grid place-items-center w-10 h-10 rounded-xl bg-primary text-primary-foreground"><Sun size={22} strokeWidth={2.5} /></span>
          <span className="font-display font-extrabold text-lg tracking-tight text-secondary">Green Era • Admin</span>
        </div>
        <h1 className="font-display font-bold text-3xl text-secondary tracking-tighter">Painel de leads</h1>
        <p className="mt-2 text-muted-foreground text-sm">Entre para gerenciar os contatos recebidos.</p>

        <form onSubmit={submit} className="mt-8 space-y-3" data-testid="login-form">
          <input className={field} type="email" placeholder="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
          <input className={field} type="password" placeholder="Senha" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
          {error && <p className="text-sm text-destructive" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 px-6 py-4 rounded-full bg-primary text-primary-foreground font-bold hover:brightness-105 active:scale-[0.98] transition-all disabled:opacity-60" data-testid="login-submit">
            {loading && <Loader2 size={18} className="animate-spin" />} Entrar
          </button>
        </form>
        <a href="/" className="mt-6 block text-center text-sm text-muted-foreground hover:text-primary transition-colors">← Voltar ao site</a>
      </motion.div>
    </div>
  );
}
